// copied from VPC, edited

import {
  createLastNWindow,
  DataPointsApiResponse,
  DataRow,
  DataTable,
  getDefinitionWithServerOrDefaultWindow,
  materializeTable,
} from '@tableau/metrics-engine';

import { FeatureFlag, FeatureFlagService } from '../../services/FeatureFlagService';

// import { IMetricInfo } from '../../models/IMetricInfo';
// import { MetricDataList } from '../../models/IMetricDataList';
// import { MetricCardProps } from '@tableau/metrics-shared-widgets-dom';

// export const metricCardProps = (metric: DataPointsApiResponse): MetricCardProps => {
//   const data = metric.data ? metric.data : [];
//   const measureFormat = getMeasureFormatString(metric.definition);

//   const defaultWindow = defaultDateWindow(dateTruncFromGranularity(getTimestampGranularity(metric.definition)));
//   const definitionWithDefaultWindow = getDefinitionWithServerOrDefaultWindow(
//     metric.definition,
//     defaultWindow,
//     FeatureFlagService.instance.getValue(FeatureFlag.metricsDateWindowEnabled)
//   );

//   const materializedData = materializeTable(definitionWithDefaultWindow, data);
//   const dataToRender = materializedData.unwrapOr([]);

//   const metricsReferenceLineEnabled = FeatureFlagService.instance.getValue(FeatureFlag.metricsReferenceLineEnabled);

//   return {
//     testId: 'metric-card',
//     data: dataToRender,
//     definition: definitionWithDefaultWindow,
//     lastUpdatedTimestamp: metric.dataRefreshedTimestamp,
//     measureFormat,
//     suspended: false,
//     metricColorIndicatorsEnabled: FeatureFlagService.instance.getValue(FeatureFlag.metricsColorIndicatorsEnabled),
//     metricsReferenceLineEnabled,
//   };
// };

export const getTableWithDefaultComparison = (metric: DataPointsApiResponse): DataTable => {
  const data = metric.data ? metric.data : [];
  const definition = getDefinitionWithServerOrDefaultWindow(
    metric.definition,
    createLastNWindow(100),
    FeatureFlagService.instance.getValue(FeatureFlag.metricsDateWindowEnabled)
  );

  const materializedData = materializeTable(definition, data);
  return materializedData.unwrapOr([]);
};

// export const getMergedMetricInfo = (metricInfo: IMetricInfo, metricDataList: MetricDataList): IMetricInfo => {
//   const data = metricDataList.data[metricInfo.id];
//   if (data) {
//     return {
//       ...metricInfo,
//       dataPoints: parseDataPoints(data.points, maxPrecision(data.schema?.measure?.format)),
//       schema: data.schema,
//       dataRefreshedTimestamp: data.dataRefreshedTimestamp,
//     };
//   } else {
//     return metricInfo;
//   }
// };

export const getMetricMeasure = (metric: DataPointsApiResponse, measureAccessor: (point: DataRow) => number): number | undefined => {
  return measureAccessor(metric.data[metric.data.length - 1]);
};
